export function queryAdder(url, params) {
//    console.log('Init', url, params);
    if (params && typeof params === 'object' && !Array.isArray(params)) {
        let keys = Object.keys(params)
        if (keys.length > 0) {
            url += `?`
            for (let i in keys) {
                if (keys.length - 1 !== i) {
                    url += `${keys[i]}=${params[keys[i]]}&`
                } else {
                    url += `${keys[i]}=${params[keys[i]]}`
                }
            }
        }
    }
//    console.log('Final', url);
    return url
}

export function DownloadFile(fileURL, fileName) {
    // for non-IE
    if (!window.ActiveXObject) {
        var save = document.createElement('a');
        save.href = fileURL;
        save.target = '_blank';
        var filename = fileURL.substring(fileURL.lastIndexOf('/') + 1);
        save.download = fileName || filename;
        if (navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
            document.location = save.href;
// window event not working here
        } else {
            var evt = new MouseEvent('click', {
                'view': window,
                'bubbles': true,
                'cancelable': false
            });
            save.dispatchEvent(evt);
            (window.URL || window.webkitURL).revokeObjectURL(save.href);
        }
    }

    // for IE < 11
    else if (!!window.ActiveXObject && document.execCommand) {
        var _window = window.open(fileURL, '_blank');
        _window.document.close();
        _window.document.execCommand('SaveAs', true, fileName || fileURL)
        _window.close();
    }

}


// WEBPACK FOOTER //
// ./modules/Home/views/src/services/helper.js